import {Component, Inject, OnInit} from '@angular/core';
import {BoardsService} from "@components/boards/boards.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {BackendResponse} from "@app/interfaces/backendResponse";
import {transferArrayItem} from "@angular/cdk/drag-drop";
import {ToastrService} from "ngx-toastr";


interface Track {
    title: string;
    id: string;
    columns: any[]
}

interface Column {
    title: string,
    status: string
}

@Component({
    selector: 'app-status-settings',
    templateUrl: './status-settings.component.html',
    styleUrls: ['./status-settings.component.css']
})
export class StatusSettingsComponent implements OnInit {

    constructor(private boardsService: BoardsService,
                @Inject(MAT_DIALOG_DATA) public dialogData: any,
                private dialogRef: MatDialogRef<StatusSettingsComponent>,
                private toastr: ToastrService) {
    }

    board: any[] = [];

    loader = false;

    modalTitle = 'Podešavanje statusa';

    public tracks: Track[] = [
        {
            title: 'Otvoreni',
            id: 'todo',
            columns: []

        },
        {
            title: 'U radu',
            id: 'inprogress',
            columns: []
        },
        {
            title: 'Završeni',
            id: 'ddone',
            columns: []
        }
    ];

    get trackIds(): string[] {
        return this.tracks.map(track => track.id);
    }


    ngOnInit() {
        this.loader = true;
        let id = this.dialogData.board_id;
        this.getBoardData(id);
        this.loader = false;

    }

    // podaci o boardu cije statuse zelimo da postavimo
    getBoardData(id) {
        return new Promise((resolve, reject) => {
            this.boardsService.getBoard(id).subscribe((responseData: BackendResponse) => {
                if (responseData.type == 'success') {
                    this.board = responseData.data;
                    let columns: any[] = this.board['columns'];
                    columns.forEach((item: Column) => {
                        if (item.status == 'todo') {
                            this.tracks[0].columns.push(item);
                        } else if (item.status == 'inprogress') {
                            this.tracks[1].columns.push(item);
                        } else if (item.status == 'ddone') {
                            this.tracks[2].columns.push(item);
                        }
                    });

                    resolve();
                } else reject();
            }, error1 => {
                reject(error1);
            })
        })
    }

    closeModal() {
        this.dialogRef.close();
    }

    onTalkDrop(event) {
        if (event.container.id === event.previousContainer.id) {
            return;
        }

        transferArrayItem(event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex);

        event.container.data.map(item => {
            item['status'] = event.container.id;
        })
    }

    saveChanges() {
        let data = [];
        return new Promise((resolve, reject) => {
            this.tracks.forEach(item => {
                if (item.columns.length == 0) {
                    data = [];
                    resolve(false);
                }
                let columns: any[] = item.columns;
                columns.map(column => {
                    if (column['tasks']) {

                        delete column['tasks'];
                    }
                });
                data = data.concat(item.columns);
            });
            resolve(true);
        }).then(result => {
            if (result === true) {
                this.boardsService.onColumnStatusesChange(data, this.board['_id']).subscribe((responseData: BackendResponse) => {
                    if (responseData.type == 'success') {
                        this.toastr.success('Podaci su sačuvani.');
                        this.dialogRef.close();
                    } else {
                        this.toastr.error('Došlo je do greške, molimo Vas obratite se korisniičkoj podršci.');
                    }
                });
            } else {
                this.toastr.info('U svakoj kategoriji mora biti najmanje jedan status. Molimo Vas pravilno dodijelite statuse.');
            }
        })


    }

}
